<span *ngIf="isEmpty">{{ 'common.notSpecified' | translate }}</span>
<a
  *ngIf="!isEmpty"
  class="font-['alberta-mada-semibold'] rounded-md border-[1px] px-[12px] py-[6px] inline-flex flex-row items-center cursor-pointer no-underline gap-2"
  [ngClass]="
    color === 'secondary-variant'
      ? 'text-[var(--alberta-color-secondary-variant)]'
      : 'text-[var(--alberta-color-secondary)]'
  "
  tappable
  tabindex="0"
  (click)="open($event)"
  (keydown.enter)="open($event)"
>
  <span class="flex" [ngClass]="inline ? 'flex-row' : 'flex-col'">
    <span
      *ngFor="let line of displayLines"
      [ngClass]="inline ? 'after:content-[\',\\00a0\'] last:after:content-none' : ''"
      >{{ line }}</span
    >
  </span>
  <itl-alberta-icon class="text-base" [name]="iconName"></itl-alberta-icon>
</a>
